import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jdowhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
   <Sides/>
   <Helmet>
 
 <title>Master the Art of Java Do While: A Beginner's Tutorial Guide by CodeExampler</title>
<meta name="description" content="Java do while tutorial for beginners.CodeExampler provides Multiple java program using do while loop Programming Examples for Beginners" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java do while,java do while loop,java do while loop example
,java do while syntax,java do while example,java do while loop with user input,java program using do while loop " />
<link rel="canonical" href="https://www.codeexampler.com/java-do-while" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Do while loop in Java</h1>
    <div className="first">
        <a href="/java-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">In the do-while java loop in java will always execute at least once. 
</p>



<h2 className="headings">Do while java loop in Java Syntax :</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            {"\n"}
            <span className="qwerty-8">do</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
    
      {"\n"}
      <span className="qwerty-2">&nbsp;statement</span>
      {"\n"}
      <span className="qwerty-3">&#125; </span>
      {"\n"}
      <span className="qwerty-8">while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">condition</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
   {"\n"}
       
            </code>
          </pre>        
        </div>

<h2 className="mt-4 mh2">Do while java loop Example</h2>



<h2 className="headings">Q-Write a Program from 1 to 10 print string Do while java loop example?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
              {"\n"}
              <span className="qwerty-7">public </span>
              <span className="qwerty-5">class</span>
              <span className="qwerty-4">  Program</span>
              
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-2">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-1">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"}
      
    
              
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">1;</span>
          {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;do</span>
          {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
            <span className="qwerty-4">"Hello CodeExampler "</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
          <span className="qwerty-8">++;</span>
          {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
{"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-8">&#60;=</span>  
      <span className="qwerty-1">10</span>   
      <span className="qwerty-1">)</span>
      {"\n"}
              <span className="qwerty-3">&#125; </span>
                {"\n"}
        
        
        
        
        
           
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-5">Hello CodeExampler</span>
              {"\n"}
              <span className="qwerty-5">Hello CodeExampler</span>
              {"\n"}
              <span className="qwerty-5">Hello CodeExampler</span>
              {"\n"}
              <span className="qwerty-5">Hello CodeExampler</span>
              {"\n"}
              <span className="qwerty-5">Hello CodeExampler</span>
              {"\n"}
              <span className="qwerty-5">Hello CodeExampler</span>
              {"\n"}
              <span className="qwerty-5">Hello CodeExampler</span>
              {"\n"}
              <span className="qwerty-5">Hello CodeExampler</span>
              {"\n"}
              <span className="qwerty-5">Hello CodeExampler</span>
              {"\n"}
              <span className="qwerty-5">Hello CodeExampler</span>
              {"\n"}
              
           
                </code>{"   "}
                </pre>
          </div>
        </div>


<h2 className="mt-4 mh2">Increment in Do While java Example</h2>



<h2 className="headings">Q-Write a Program Increment of +2 value every time in Do While java loop example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4">  Program</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">1;</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;do</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"hello everyone "</span>
      <span className="qwerty-8">+</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-1">2;</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

 


 
 



{"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;while</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">a</span>
  <span className="qwerty-8">&#60;=</span>  
  <span className="qwerty-1">5</span>   
  <span className="qwerty-1">)</span>
  {"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5">hello everyone </span><span className="qwerty-3">1 </span>
          {"\n"}
          <span className="qwerty-5">hello everyone </span><span className="qwerty-3">3 </span>
          {"\n"}
          <span className="qwerty-5">hello everyone </span><span className="qwerty-3">5 </span>
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


 

<h2 className="headings">Q-Write a Program Increment in Do while java loop Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4">  Program</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">1;</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;do</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"Increment No "</span>
      <span className="qwerty-8">+</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
      <span className="qwerty-8">++;</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

 


 
 



{"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;while</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">a</span>
  <span className="qwerty-8">&#60;=</span>  
  <span className="qwerty-1">10</span>   
  <span className="qwerty-1">)</span>
  {"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5">Increment No  </span>
          <span className="qwerty-3">1 </span>
          {"\n"}
          <span className="qwerty-5">Increment No </span> <span className="qwerty-3">2 </span>
          {"\n"}
          <span className="qwerty-5">Increment No </span> <span className="qwerty-3">3 </span>
          {"\n"}
          <span className="qwerty-5">Increment No </span> <span className="qwerty-3">4 </span>
          {"\n"}
          <span className="qwerty-5">Increment No </span> <span className="qwerty-3">5 </span>
          {"\n"}
          <span className="qwerty-5">Increment No </span> <span className="qwerty-3">6 </span>
          {"\n"}
          <span className="qwerty-5">Increment No </span> <span className="qwerty-3">7 </span>
          {"\n"}
          <span className="qwerty-5">Increment No </span> <span className="qwerty-3">8 </span>
          {"\n"}
          <span className="qwerty-5">Increment No </span> <span className="qwerty-3">9 </span>
          {"\n"}
          <span className="qwerty-5">Increment No </span> <span className="qwerty-3">10 </span>
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">Decrement in Do while java Example</h2>


<h2 className="headings">Q- Write a Program decrement in Do while java Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4">  Program</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">10;</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;do</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"Decrement No "</span>
      <span className="qwerty-8">+</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
      <span className="qwerty-8">--;</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

 


 
 



{"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;while</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">a</span>
  <span className="qwerty-8">&#62;=</span>  
  <span className="qwerty-1">1</span>   
  <span className="qwerty-1">)</span>
  {"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5">Decrement No  </span>
          <span className="qwerty-3">10 </span>
          {"\n"}
          <span className="qwerty-5">Decrement No </span> <span className="qwerty-3">9 </span>
          {"\n"}
          <span className="qwerty-5">Decrement No </span> <span className="qwerty-3">8 </span>
          {"\n"}
          <span className="qwerty-5">Decrement No </span> <span className="qwerty-3">7 </span>
          {"\n"}
          <span className="qwerty-5">Decrement No </span> <span className="qwerty-3">6 </span>
          {"\n"}
          <span className="qwerty-5">Decrement No </span> <span className="qwerty-3">5 </span>
          {"\n"}
          <span className="qwerty-5">Decrement No </span> <span className="qwerty-3">4 </span>
          {"\n"}
          <span className="qwerty-5">Decrement No </span> <span className="qwerty-3">3 </span>
          {"\n"}
          <span className="qwerty-5">Decrement No </span> <span className="qwerty-3">2 </span>
          {"\n"}
          <span className="qwerty-5">Decrement No </span> <span className="qwerty-3">1 </span>
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/java-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div> 
        </div>
    </div>
)

}
export default Jdowhile;